<template>
  <div>
    <WebHeaderView :title="dataInfo.title" :right-icon="'service-o'" :right-type="'vant'" :right-key="'customer'" />
    <div class="page-content">
      <div class="news-details-page">
        <div class="news-details-container">
          <p class="news-content" v-html="dataInfo.content"></p>
          <p class="news-content" v-html="dataInfo.memo"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'ActiveInfoView',
  components: { WebHeaderView },
  data () {
    return { dataInfo: {} }
  },
  mounted () {
    const query = this.$route.query
    if (query.id) {
      this.getInf(query.id)
    }
  },
  methods: {
    async getInf (id) {
      await this.$http({
        method: 'post',
        url: 'activitydeatil',
        data: { id: id }
      }).then(data => {
        this.dataInfo = data.data
      })
    }
  }
}
</script>

<style></style>
